<template>
    <div class="main_div" :key="componentKey">
        <Loading v-show="loading" />
        <div style="height: auto">
            <n-space vertical>
                <NCard style="margin-top: 20px; margin-left: 80px; border: 0px; min-width: 800px">
                    <n-space item-style="display: flex;" align="center">
                        <div style="font-size: 20px; font-weight: bold">검사 결과 관리(개인)</div>
                    </n-space>
                    <div class="content_delimiter_line"></div>

                    <n-tabs type="line" animated v-model:value="currentTab" @update:value="handleTabChange">
                        <n-tab-pane :name="TAB.PENDING" :disabled="listLoading">
                            <template #tab>
                                <n-space align="center" :size="8" :wrap-item="false">
                                    <span>검사 대기</span>
                                    <n-spin v-if="listLoading && currentTab === TAB.PENDING" size="small" />
                                </n-space>
                            </template>
                            <n-space vertical style="margin-top: 10px">
                                <n-space align="baseline" item-style="display: flex;">
                                    <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                                        <n-input-group>
                                            <n-select
                                                v-model:value="searchTypeForPending"
                                                :options="searchOptions"
                                                style="width: 120px"
                                            />
                                            <n-input
                                                v-model:value="searchValueForPending"
                                                placeholder="검색어를 입력하세요"
                                                clearable
                                            />
                                        </n-input-group>
                                    </n-form-item>
                                    <n-form-item style="min-width: 300px" label-placement="left"> </n-form-item>
                                    <n-form-item style="margin-bottom: 0">
                                        <n-button
                                            type="primary"
                                            @click="wrappedRefreshDiagnosis({ status: TAB.PENDING })"
                                        >
                                            조회
                                        </n-button>
                                    </n-form-item>
                                </n-space>
                            </n-space>
                            <div v-if="listLoading" class="loading-indicator">검사 대기 목록을 불러오는 중...</div>
                            <div v-else-if="error" class="error-message">{{ error }}</div>
                            <div v-else>
                                <div class="table-container">
                                    <n-data-table
                                        v-if="!listLoading && !error"
                                        :columns="columns"
                                        :data="pendingOrders"
                                        :pagination="false"
                                        :bordered="false"
                                        style="margin-top: 10px"
                                    />
                                    <p v-else>등록된 검사 대기 목록 없습니다.</p>
                                </div>
                            </div>
                            <div
                                v-if="pendingOrders.length > 0 && !listLoading && !error"
                                class="pagination-controls"
                                style="margin-top: 15px; text-align: center"
                            >
                                <n-button
                                    @click="wrappedGoToPreviousPage"
                                    :disabled="currentPage === 1"
                                    style="margin-right: 8px"
                                >
                                    이전 페이지
                                </n-button>
                                <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                                <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                            </div>
                        </n-tab-pane>
                        <n-tab-pane :name="TAB.PROCESSING" :disabled="listLoading">
                            <template #tab>
                                <n-space align="center" :size="8" :wrap-item="false">
                                    <span>검사 중</span>
                                    <n-spin v-if="listLoading && currentTab === TAB.PROCESSING" size="small" />
                                </n-space>
                            </template>
                            <n-space vertical style="margin-top: 10px">
                                <n-space align="baseline" item-style="display: flex;">
                                    <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                                        <n-input-group>
                                            <n-select
                                                v-model:value="searchTypeForProcessing"
                                                :options="searchOptions"
                                                style="width: 120px"
                                            />
                                            <n-input
                                                v-model:value="searchValueForProcessing"
                                                placeholder="검색어를 입력하세요"
                                                clearable
                                            />
                                        </n-input-group>
                                    </n-form-item>
                                    <n-form-item style="min-width: 300px" label-placement="left"> </n-form-item>
                                    <n-form-item style="margin-bottom: 0">
                                        <n-button
                                            type="primary"
                                            @click="wrappedRefreshDiagnosis({ status: TAB.PROCESSING })"
                                        >
                                            조회
                                        </n-button>
                                    </n-form-item>
                                </n-space>
                            </n-space>
                            <div v-if="listLoading" class="loading-indicator">검사 대기 목록을 불러오는 중...</div>
                            <div v-else-if="error" class="error-message">{{ error }}</div>
                            <div v-else>
                                <div class="table-container">
                                    <n-data-table
                                        v-if="!listLoading && !error"
                                        :columns="columns"
                                        :data="processingOrders"
                                        :pagination="false"
                                        :bordered="false"
                                        style="margin-top: 10px"
                                    />
                                    <p v-else>등록된 검사 중 목록 없습니다.</p>
                                </div>
                            </div>

                            <div
                                v-if="processingOrders.length > 0 && !listLoading && !error"
                                class="pagination-controls"
                                style="margin-top: 15px; text-align: center"
                            >
                                <n-button
                                    @click="wrappedGoToPreviousPage"
                                    :disabled="currentPage === 1"
                                    style="margin-right: 8px"
                                >
                                    이전 페이지
                                </n-button>
                                <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                                <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage"> 다음 페이지 </n-button>
                            </div>
                        </n-tab-pane>
                        <n-tab-pane :name="TAB.COMPLETED" :disabled="listLoading">
                            <template #tab>
                                <n-space align="center" :size="8" :wrap-item="false">
                                    <span>검사 완료</span>
                                    <n-spin v-if="listLoading && currentTab === TAB.COMPLETED" size="small" />
                                </n-space>
                            </template>
                            <n-space vertical style="margin-top: 10px">
                                <n-space align="center" item-style="display: flex;">
                                    <n-form-item label="검색" style="min-width: 350px" label-placement="left">
                                        <n-input-group>
                                            <n-select
                                                v-model:value="searchTypeForCompleted"
                                                :options="searchOptions"
                                                style="width: 120px"
                                            />
                                            <n-input
                                                v-model:value="searchValueForCompleted"
                                                placeholder="검색어를 입력하세요"
                                                clearable
                                            />
                                        </n-input-group>
                                    </n-form-item>
                                    <n-form-item
                                        label="검사 완료일 기간 선택"
                                        style="min-width: 300px"
                                        label-placement="left"
                                    >
                                        <n-date-picker v-model:value="dateRange" type="daterange" clearable />
                                    </n-form-item>
                                    <n-form-item style="margin-bottom: 0" label-placement="left">
                                        <!-- To align with the DatePicker's FormItem -->
                                        <n-button
                                            type="primary"
                                            @click="fetchCompletedProjectsByDateRange"
                                            :disabled="!dateRange && !searchValueForCompleted"
                                        >
                                            조회
                                        </n-button>
                                    </n-form-item>
                                </n-space>
                            </n-space>
                            <div v-if="showCompletedResults">
                                <Loading v-show="listLoading" />
                                <div v-if="!listLoading && error" class="error-message" style="margin-top: 10px">
                                    {{ error }}
                                </div>
                                <n-data-table
                                    v-if="!listLoading && !error && completedOrders.length > 0"
                                    :columns="columns"
                                    :data="completedOrders"
                                    :pagination="false"
                                    :bordered="false"
                                    style="margin-top: 10px"
                                />
                                <p
                                    v-if="!listLoading && !error && completedOrders.length === 0"
                                    style="margin-top: 10px; text-align: center"
                                >
                                    선택된 기간에 해당하는 완료된 검사가 없습니다.
                                </p>

                                <div
                                    v-if="completedOrders.length > 0 && !listLoading && !error"
                                    class="pagination-controls"
                                    style="margin-top: 15px; text-align: center"
                                >
                                    <n-button
                                        @click="wrappedGoToPreviousPage"
                                        :disabled="currentPage === 1"
                                        style="margin-right: 8px"
                                    >
                                        이전 페이지
                                    </n-button>
                                    <span style="margin: 0 10px">{{ currentPage }} 페이지</span>
                                    <n-button @click="wrappedGoToNextPage" :disabled="!hasNextPage">
                                        다음 페이지
                                    </n-button>
                                </div>
                            </div>
                            <div v-else style="margin-top: 20px; text-align: center; color: #777">
                                조회할 기간을 선택해주세요.
                            </div>
                        </n-tab-pane>
                    </n-tabs>

                    <!-- Examinee Details Modal -->
                    <n-modal v-model:show="showExamineeModal" preset="card" style="width: 900px" :title="modalTitle">
                        <template #header-extra>
                            <n-button @click="viewResult(selectedProjectForModal!)" type="info" size="small">
                                <template #icon>
                                    <n-icon>
                                        <RefreshIcon />
                                    </n-icon>
                                </template>
                                새로고침
                            </n-button>
                        </template>
                        <div style="max-height: 600px; overflow-y: auto; padding-right: 15px">
                            <n-descriptions
                                v-if="selectedProjectForModal"
                                label-placement="left"
                                :column="4"
                                :label-style="{ width: '150px' }"
                                bordered
                                size="small"
                                style="margin-bottom: 15px"
                            >
                                <n-descriptions-item label="검사 이름" :span="2">
                                    {{ selectedProjectForModal.name || "N/A" }}
                                </n-descriptions-item>
                                <n-descriptions-item label="상태" :span="2">
                                    {{ getProjectStatusString(selectedProjectForModal.status) }}
                                </n-descriptions-item>
                                <template v-if="showExamineeModal.status == constant.projectStatus.ING">
                                    <n-descriptions-item label="검사 링크" :span="4">
                                        <a
                                            :href="common.getSurveyUrl(selectedProjectForModal.SK!)"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            v-if="selectedProjectForModal.responder_uri"
                                        >
                                            {{ common.getSurveyUrl(selectedProjectForModal.SK!) }}
                                        </a>
                                        <span v-else style="color: red"> 검사가 활성화 되면 링크가 표시됩니다. </span>
                                    </n-descriptions-item>
                                </template>
                                <template v-else>
                                    <n-descriptions-item label="검사 링크" :span="4">
                                        <span> N/A </span>
                                    </n-descriptions-item>
                                </template>
                                <n-descriptions-item label="시작일" :span="2">
                                    {{
                                        common.getYYYMMDDStringFormat(selectedProjectForModal.start_target_date) ||
                                        "N/A"
                                    }}
                                </n-descriptions-item>
                                <n-descriptions-item label="종료일" :span="2">
                                    {{
                                        common.getYYYMMDDStringFormat(selectedProjectForModal.end_target_date) || "N/A"
                                    }}
                                </n-descriptions-item>

                                <n-descriptions-item
                                    v-if="
                                        selectedProjectForModal.status == constant.projectStatus.ING || 
                                        selectedProjectForModal.status == constant.projectStatus.COMPLETED
                                    "
                                    label="진단검사분석요청"
                                    :span="4"
                                >
                                    <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: center">
                                        <n-tooltip 
                                            v-if="selectedProjectForModal.status == constant.projectStatus.ING"
                                            trigger="hover">
                                            <template #trigger>
                                                <n-button
                                                    size="small"
                                                    :loading="isStudentReporting[selectedProjectForModal.SK]"
                                                    :disabled="isDoingJob"
                                                    type="primary"
                                                    @click="doRequestExamineeReport(selectedProjectForModal.SK)"
                                                >
                                                    결과리포트 학생용 생성요청
                                                </n-button>
                                            </template>
                                            {{ selectedProjectForModal.name }}의 모든 학생들에 대해서 개별 리포트 생성을
                                            요청합니다.
                                        </n-tooltip>
                                    </div>
                                </n-descriptions-item>

                                <n-descriptions-item
                                    v-if="
                                        selectedProjectForModal.status == constant.projectStatus.ING || 
                                        selectedProjectForModal.status == constant.projectStatus.COMPLETED
                                    "
                                    label="특수기능"
                                    :span="4"
                                >
                                    <n-space :size="8">
                                        <n-tooltip trigger="hover">
                                            <template #trigger>
                                                <n-button
                                                    size="small"
                                                    type="primary"
                                                    :loading="isStudentReportingUsingSheet[selectedProjectForModal.SK]"
                                                    :disabled="isDoingJob"
                                                    @click="doRequestExamineeReportUsingSheet(selectedProjectForModal.SK)"
                                                >
                                                    구글 시트기반 학생용 리포트 생성
                                                </n-button>
                                            </template>
                                            구글 시트 기반으로 학생용 리포트 생성을 요청합니다.
                                        </n-tooltip>
                                        <n-tooltip trigger="hover">
                                            <template #trigger>
                                                <n-button
                                                    size="small"
                                                    type="info"
                                                    :loading="isSendingBulkEmail[selectedProjectForModal.SK]"
                                                    :disabled="isDoingJob"
                                                    @click="doSendUnsentProjectEmails(selectedProjectForModal)"
                                                >
                                                    진단검사 이메일 전송
                                                </n-button>
                                            </template>
                                            진단완료된 학생들 중 아직 이메일을 전송하지 않은 학생들에게 이메일을 일괄 전송합니다.
                                        </n-tooltip>
                                    </n-space>
                                </n-descriptions-item>
                            </n-descriptions>

                            <ExamineeTable
                                v-if="
                                    selectedProjectForModal?.examinees && selectedProjectForModal.examinees.length > 0
                                "
                                :examinees="selectedProjectForModal.examinees"
                                :class-type="selectedProjectForModal.type"
                            />
                            <p v-else-if="selectedProjectForModal" style="text-align: center; margin-top: 20px">
                                등록된 학생 정보가 없습니다.
                            </p>
                        </div>
                    </n-modal>
                </NCard>
            </n-space>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, h, computed, FunctionalComponent, toRaw, watch, onUnmounted } from "vue";
import {
    NSpace,
    NCard,
    NButton,
    NDataTable,
    NModal,
    NSelect,
    NDescriptions,
    NDescriptionsItem,
    NDatePicker,
    NFormItem,
    useMessage,
    NTabs,
    NTabPane,
    useNotification,
    useDialog,
    DataTableColumns,
    NSpin,
    NInput,
    NIcon,
    NTooltip,
    NInputGroup,
    NTag,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { RefreshOutline as RefreshIcon, CalendarOutline as CalendarIcon } from "@vicons/ionicons5";
import { getCallable, getCallableOption, getRequestEndpoint } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useAuth } from "@/composables/useAuth";
import { QueryInfo, ChangeStatus } from "@/model/base";
import { Order, OrderItem } from "@/model/order";
import { Project } from "@/model/project";
import { Examinee } from "@/model/examinee";
import { Organization } from "@/model/organization";

import { usePagination } from "@/composables/usePagination";
import { getProjectStatusString } from "@/composables/useOrderForm"; // For status display
import { USER_ROUTES } from "@/assets/route_constants";
import { useDownload } from "@/composables/useDownload";
import { useActionDialog } from "@/composables/useDialog";
const { show: showActionDialog } = useActionDialog();
const { downloadReportFile } = useDownload();

const TAB = {
    PENDING: "pending",
    PROCESSING: "processing",
    COMPLETED: "completed",
};

const { loading } = useAuth();
const router = useRouter();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const componentKey = ref(0);
const currentTab = ref("pending");

const dateRange = ref<[number, number] | null>(null);
const showCompletedResults = ref(false);

const showExamineeModal = ref(false);
const selectedProjectForModal = ref<Project | null>(null);

const selectedProject = ref<Project | null>(null);

const searchValueForPending = ref<string | null>(null);
const searchTypeForPending = ref("email");
const searchValueForProcessing = ref<string | null>(null);
const searchTypeForProcessing = ref("email");
const searchValueForCompleted = ref<string | null>(null);
const searchTypeForCompleted = ref("email");

const isDoingJob = ref(false);
const isStudentReporting = ref<{ [key: string]: boolean }>({});
const isDownloadingStudentReport = ref<{ [key: string]: boolean }>({});
const isDeletingStudentReport = ref<{ [key: string]: boolean }>({});
const isStudentReportingUsingSheet = ref<{ [key: string]: boolean }>({});
const isSendingStudentEmail = ref<{ [key: string]: boolean }>({});
const isSendingBulkEmail = ref<{ [key: string]: boolean }>({});

const getPersonalWillOpenProjectsCallable = getCallable("getPersonalWillOpenProjects");
const getPersonalOpenedProjectsCallable = getCallable("getPersonalOpenedProjects");
const getPersonalCompletedProjectsCallable = getCallable("getPersonalCompletedProjects");
const openOneProjectCallable = getCallable("openOneProject");
const getProjectContainsExamnineesCallable = getCallable("getProjectContainsExamninees");
const getProjectCallable = getCallable("getProject");
const deleteExaminieeReportDataCallable = getCallable("deleteExaminieeReportData");
const requestProjectReportGenerationCallable = getCallableOption("requestProjectReportGeneration");
const updateProjectEndDateCallable = getCallable("updateProjectEndDate");
const requestProjectReportGenerationUsingSheetCallable = getCallableOption("requestProjectReportGenerationUsingSheet");
const sendExamineeReportEmailCallable = getCallable("sendExamineeReportEmail");
const sendUnsentProjectResultEmailsCallable = getCallable("sendUnsentProjectResultEmails");
const updateExamineeEmailCallable = getCallable("updateExamineeEmail");


const searchOptions = [{ label: "이메일", value: "email" }, { label: "검사명", value: "name" }];

const {
    paginatedItems: diagnosisItems,
    listLoading,
    error,
    currentPage,
    hasNextPage,
    goToNextPage: composableGoToNextPage,
    goToPreviousPage: composableGoToPreviousPage,
    refreshData: composableRefreshDiagnosis,
} = usePagination<Project, { status?: string; startDate?: string; endDate?: string }>(
    async (params) => getProjectByStatus(params),
    10, // 페이지 크기
    { status: currentTab.value }
);

const getProjectByStatus = async (params: any) => {
    if (params.status == TAB.PENDING) {
        if (searchValueForPending.value && searchValueForPending.value.trim() !== "") {
            params.searchKey = searchTypeForPending.value;
            params.searchValue = searchValueForPending.value.trim();
        }
        return await getPersonalWillOpenProjectsCallable(params);
    } else if (params.status == TAB.PROCESSING) {
        if (searchValueForProcessing.value && searchValueForProcessing.value.trim() !== "") {
            params.searchKey = searchTypeForProcessing.value;
            params.searchValue = searchValueForProcessing.value.trim();
        }
        return await getPersonalOpenedProjectsCallable(params);
    } else if (params.status == TAB.COMPLETED) {
        if (searchValueForCompleted.value && searchValueForCompleted.value.trim() !== "") {
            params.searchKey = searchTypeForCompleted.value;
            params.searchValue = searchValueForCompleted.value.trim();
        }
        if ((params.startDate && params.endDate) || (params.searchKey && params.searchValue)) {
            return await getPersonalCompletedProjectsCallable(params);
        }
        return { data: { Items: [], LastEvaluatedKey: null } };
    } else {
        return [];
    }
};

async function wrappedRefreshDiagnosis(filters?: { status?: string }) {
    loading.value = true;
    await composableRefreshDiagnosis(filters);
    loading.value = false;
}

async function wrappedGoToNextPage() {
    if (!hasNextPage.value) return;
    loading.value = true;
    await composableGoToNextPage();
    loading.value = false;
}

async function wrappedGoToPreviousPage() {
    if (currentPage.value <= 1) return;
    loading.value = true;
    await composableGoToPreviousPage();
    loading.value = false;
}

async function fetchCompletedProjectsByDateRange() {
    const hasDateRange = !!dateRange.value;
    const hasSearch = searchValueForCompleted.value && searchValueForCompleted.value.trim() !== "";

    if (!hasDateRange && !hasSearch) {
        message.error("기간 또는 검색어를 입력해주세요.");
        return;
    }

    let startDate: string | undefined;
    let endDate: string | undefined;

    if (hasDateRange && dateRange.value) {
        const [startTimestamp, endTimestamp] = dateRange.value;
        startDate = common.getYYYYMMDD(startTimestamp);
        endDate = common.getYYYYMMDD(endTimestamp);
    }

    showCompletedResults.value = false;
    loading.value = true;

    await composableRefreshDiagnosis({
        status: TAB.COMPLETED,
        startDate,
        endDate,
    });
    showCompletedResults.value = true;
    loading.value = false;
}

const columns = [
    {
        title: "신청자 이메일",
        key: "email",
        resizable: true,
    },
    {
        title: "검사 이름",
        key: "name",
        resizable: true,
    },
    {
        title: "최종변경일",
        key: "lastUpdatedDate",
        resizable: true,
        render: (row: any) => common.getYYYYMMDD2(Number(row.lastUpdatedDate)),
    },
    {
        title: "시작일",
        key: "start_target_date",
        resizable: true,
        render: (row: any) => common.getYYYMMDDStringFormat(row.start_target_date),
    },
    {
        title: "종료일",
        key: "end_target_date",
        resizable: true,
        render(row: Project) {
            let hlist: any  = [];
            hlist.push(h("span", common.getYYYMMDDStringFormat(row.end_target_date)));
            if(row.status != constant.projectStatus.ING) {
                hlist.push(h(
                    NButton,
                    {
                        strong: true,
                        tertiary: true,
                        size: "small",
                        onClick: () => showEndDateChangeDialog(row),
                    },
                    { default: () => "변경" }
                ));
            }
            return h(
                NSpace,
                { align: "center" },
                {
                    default: () => hlist,
                }
            );
        },
    },
    {
        title: "",
        key: "actions",
        render(row: Project) {
            return h(
                NButton,
                {
                    strong: true,
                    tertiary: true,
                    size: "small",
                    onClick: () => viewResult(row),
                },
                { default: () => "상세보기" }
            );
        },
    },
];

const pendingOrders = computed(() => {
    return diagnosisItems.value;
});

const processingOrders = computed(() => {
    return diagnosisItems.value;
});

const completedOrders = computed(() => {
    return diagnosisItems.value;
});

const modalTitle = computed(() => {
    if (selectedProjectForModal.value) {
        return `${selectedProjectForModal.value.name}`;
    }
    return "검사 결과";
});

interface ExamineeTableProps {
    examinees: Examinee[];
    classType?: string;
}

const createExamineeTableColumns = (classType?: string): DataTableColumns<Examinee> => {
    const isUniversityType = classType === "putt_u" || classType === "tec";
    return [
        {
            title: "학생 정보 및 결과리포트 / 이메일 관리",
            key: "examinee_info",
            render: (row, idx) => {
                const isSent = !!row.email_sent;
                const hasEmail = !!row.email;
                const numLabel = isUniversityType ? "학번" : "번호";
                const numVal = isUniversityType
                    ? row.student_num || row.num || "N/A"
                    : row.num || "N/A";

                // 1행: 인증코드 | 번호/학번 | 성명 (성별 / 생년월일)
                const row1 = h(
                    "div",
                    {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "8px",
                            paddingBottom: "8px",
                            borderBottom: "1px dashed #e8e8e8",
                            fontSize: "13px",
                        },
                    },
                    [
                        // 인증코드
                        h(
                            "span",
                            { style: { display: "inline-flex", alignItems: "center", gap: "4px" } },
                            [
                                h("span", { style: { color: "#666" } }, "인증코드:"),
                                h(
                                    "strong",
                                    { style: { color: "#e03131", letterSpacing: "0.5px", fontSize: "14px" } },
                                    row.authCode || "N/A"
                                ),
                            ]
                        ),
                        h("span", { style: { color: "#d9d9d9" } }, "|"),
                        // 번호 / 학번
                        h(
                            "span",
                            { style: { display: "inline-flex", alignItems: "center", gap: "4px" } },
                            [
                                h("span", { style: { color: "#666" } }, `${numLabel}:`),
                                h(
                                    "span",
                                    {
                                        style: {
                                            fontWeight: numVal !== "N/A" ? "bold" : "normal",
                                            color: numVal !== "N/A" ? "#333" : "#999",
                                        },
                                    },
                                    numVal
                                ),
                            ]
                        ),
                        h("span", { style: { color: "#d9d9d9" } }, "|"),
                        // 성명 및 인적사항
                        h(
                            "span",
                            { style: { fontWeight: "bold", fontSize: "14px", color: "#1f2225" } },
                            row.name || "N/A"
                        ),
                        h(
                            "span",
                            { style: { color: "#666" } },
                            `(${common.getGenderString(row.gender)} / ${row.dob || "생년월일 미등록"})`
                        ),
                    ]
                );


                // 2행: 결과리포트 및 이메일 전송/수정 영역
                let row2;
                if (row.report_file) {
                    let tooltipText = "전송완료";
                    if (row.email_sent_at) {
                        try {
                            const d = new Date(row.email_sent_at);
                            if (!isNaN(d.getTime())) {
                                tooltipText = `${common.formatDateToYYYYMMDD2(d)} 전송됨`;
                            }
                        } catch {}
                    }

                    row2 = h(
                        "div",
                        {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexWrap: "wrap",
                                gap: "12px",
                                paddingTop: "8px",
                            },
                        },
                        [
                            // 좌측: 이메일 정보 & 전송 상태
                            h(
                                "div",
                                { style: { display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" } },
                                [
                                    h(
                                        "div",
                                        { style: { display: "flex", alignItems: "center", gap: "6px" } },
                                        [
                                            h("span", { style: { fontSize: "13px", color: "#666" } }, "이메일:"),
                                            h(
                                                "span",
                                                {
                                                    style: {
                                                        fontSize: "13px",
                                                        fontWeight: row.email ? "500" : "normal",
                                                        color: row.email ? "#1f2225" : "#999",
                                                    },
                                                },
                                                row.email || "미등록"
                                            ),
                                            h(
                                                NButton,
                                                {
                                                    size: "tiny",
                                                    quaternary: true,
                                                    type: "primary",
                                                    onClick: () => showEmailEditDialog(row),
                                                },
                                                { default: () => "수정" }
                                            ),
                                        ]
                                    ),
                                    h("span", { style: { color: "#d9d9d9" } }, "|"),
                                    h(
                                        "div",
                                        { style: { display: "flex", alignItems: "center", gap: "6px" } },
                                        [
                                            h("span", { style: { fontSize: "13px", color: "#666" } }, "전송상태:"),
                                            isSent
                                                ? h(
                                                      NTooltip,
                                                      { trigger: "hover" },
                                                      {
                                                          trigger: () =>
                                                              h(
                                                                  NTag,
                                                                  { type: "success", size: "small", round: true, style: "cursor: pointer;" },
                                                                  { default: () => "전송완료" }
                                                              ),
                                                          default: () => tooltipText,
                                                      }
                                                  )
                                                : h(
                                                      NTag,
                                                      {
                                                          size: "small",
                                                          round: true,
                                                          bordered: false,
                                                          style: "color: #999; background: #f0f0f0;",
                                                      },
                                                      { default: () => "미전송" }
                                                  ),
                                        ]
                                    ),
                                ]
                            ),
                            // 우측: 결과리포트 액션 버튼들
                            h(
                                "div",
                                { style: { display: "flex", alignItems: "center", gap: "8px" } },
                                [
                                    h(
                                        NButton,
                                        {
                                            strong: true,
                                            tertiary: true,
                                            size: "small",
                                            loading: isDownloadingStudentReport.value[row.SK],
                                            onClick: () => downloadExamineeReportFile(row, classType),
                                        },
                                        { default: () => "리포트 다운로드" }
                                    ),
                                    row.authCode
                                        ? h(
                                              NButton,
                                              {
                                                  type: "error",
                                                  size: "small",
                                                  loading: isDeletingStudentReport.value[row.SK],
                                                  onClick: () => deleteExamineeReportFile(row),
                                              },
                                              { default: () => "삭제" }
                                          )
                                        : null,
                                    h(
                                        NTooltip,
                                        { trigger: "hover" },
                                        {
                                            trigger: () =>
                                                h(
                                                    NButton,
                                                    {
                                                        type: isSent ? "warning" : "info",
                                                        size: "small",
                                                        disabled: !hasEmail,
                                                        loading: isSendingStudentEmail.value[row.SK],
                                                        onClick: () => doSendExamineeEmail(row, selectedProjectForModal.value),
                                                    },
                                                    { default: () => (isSent ? "이메일 재전송" : "이메일 전송") }
                                                ),
                                            default: () =>
                                                !hasEmail
                                                    ? "이메일 주소를 입력해주세요"
                                                    : isSent
                                                    ? "결과리포트 이메일 재전송"
                                                    : "결과리포트 이메일 전송",
                                        }
                                    ),
                                ]
                            ),
                        ]
                    );
                } else {
                    row2 = h(
                        "div",
                        { style: { paddingTop: "8px" } },
                        [
                            h(
                                NTag,
                                { size: "small", bordered: false, style: "color: #999; background: #f7f7f7;" },
                                { default: () => "진단 미완료 (결과리포트 생성 전)" }
                            ),
                        ]
                    );
                }

                return h(
                    "div",
                    {
                        style: {
                            padding: "10px 14px",
                            background: "#fafafa",
                            borderRadius: "6px",
                            border: "1px solid #f0f0f0",
                        },
                    },
                    [row1, row2]
                );
            },
        },
    ];
};

const ExamineeTable: FunctionalComponent<ExamineeTableProps> = (props) => {
    const columns = createExamineeTableColumns(props.classType);
    return h(NDataTable, {
        columns: columns,
        data: props.examinees,
        bordered: false,
        singleLine: false,
        size: "small",
        style: { marginTop: "15px" },
    });
};

function triggerModalProjectUpdate() {
    if (selectedProjectForModal.value) {
        if (selectedProjectForModal.value.examinees) {
            selectedProjectForModal.value.examinees = [...selectedProjectForModal.value.examinees];
        }
        selectedProjectForModal.value = { ...selectedProjectForModal.value };
    }
}

function showEmailEditDialog(examinee: Examinee) {
    const newEmailRef = ref<string>(examinee.email || "");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const d = dialog.create({
        title: "학생 이메일 수정",
        content: () =>
            h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
                h("p", `"${examinee.name}" 학생의 이메일 주소를 입력해주세요.`),
                h(NInput, {
                    value: newEmailRef.value,
                    placeholder: "example@email.com",
                    onUpdateValue: (value: string) => {
                        newEmailRef.value = value;
                    },
                }),
            ]),
        positiveText: "저장",
        negativeText: "취소",
        onPositiveClick: () => {
            const emailVal = newEmailRef.value.trim();
            if (!emailVal || !emailRegex.test(emailVal)) {
                message.error("올바른 이메일 형식을 입력해주세요.");
                return false;
            }
            d.loading = true;
            updateExamineeEmailCallable({
                examineeSK: examinee.SK,
                email: emailVal,
            })
                .then((res: any) => {
                    if (common.evalFunctionResult(res)) {
                        examinee.email = emailVal;
                        triggerModalProjectUpdate();
                        message.success("이메일이 성공적으로 수정되었습니다.");
                        d.destroy();
                    } else {
                        d.loading = false;
                        notification.error({
                            title: "이메일 수정 실패",
                            description: common.getResultError(res) || "이메일 수정에 실패했습니다.",
                            duration: 3000,
                        });
                    }
                })
                .catch((err: any) => {
                    d.loading = false;
                    notification.error({
                        title: "오류 발생",
                        description: err.message || "이메일 수정 중 오류가 발생했습니다.",
                        duration: 3000,
                    });
                });

            return false;
        },
    });
}


function doSendExamineeEmail(examinee: Examinee, project: Project | null) {
    if (!project) return;
    if (!examinee.email) {
        message.warning("학생의 이메일 주소가 등록되지 않았습니다.");
        return;
    }
    if (!examinee.report_file) {
        message.warning("결과리포트가 아직 생성되지 않았습니다.");
        return;
    }

    const isResend = !!examinee.email_sent;
    const d = dialog.create({
        title: isResend ? "결과리포트 이메일 재전송" : "결과리포트 이메일 전송",
        type: isResend ? "warning" : "info",
        content: () =>
            h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
                isResend
                    ? h("p", { style: "color: #e6a23c; font-weight: bold;" }, "이미 이메일이 전송된 학생입니다.")
                    : null,
                h(
                    "p",
                    `"${examinee.name}" 학생(${examinee.email})에게 결과리포트 이메일을 ${isResend ? "다시 " : ""}전송하시겠습니까?`
                ),
            ]),
        positiveText: "전송",
        negativeText: "취소",
        onPositiveClick: () => {
            d.loading = true;
            isSendingStudentEmail.value[examinee.SK] = true;
            sendExamineeReportEmailCallable({
                projectSK: project.SK,
                examineeSK: examinee.SK,
            })
                .then((res: any) => {
                    if (common.evalFunctionResult(res)) {
                        const payload = res.data?.data || res.data || {};
                        examinee.email_sent = true;
                        examinee.email_sent_at = payload.email_sent_at || new Date().toISOString();
                        triggerModalProjectUpdate();
                        message.success("이메일이 성공적으로 전송되었습니다.");
                        d.destroy();
                    } else {
                        d.loading = false;
                        notification.error({
                            title: "이메일 전송 실패",
                            description: common.getResultError(res) || "이메일 전송에 실패했습니다.",
                            duration: 3000,
                        });
                    }
                })
                .catch((err: any) => {
                    d.loading = false;
                    notification.error({
                        title: "오류 발생",
                        description: err.message || "이메일 전송 중 오류가 발생했습니다.",
                        duration: 3000,
                    });
                })
                .finally(() => {
                    isSendingStudentEmail.value[examinee.SK] = false;
                });

            return false;
        },
    });
}



function doSendUnsentProjectEmails(project: Project | null) {
    if (!project || !project.examinees) return;

    const examinees = project.examinees;
    const completedStudents = examinees.filter((e) => !!e.report_file);
    const alreadySentStudents = completedStudents.filter((e) => !!e.email_sent);
    const noEmailStudents = completedStudents.filter((e) => !e.email_sent && !e.email);
    const targetStudents = completedStudents.filter((e) => !e.email_sent && !!e.email);

    if (targetStudents.length === 0) {
        message.warning("전송할 대상 학생이 없습니다. (진단완료 및 미전송 상태인 이메일 보유 학생 없음)");
        return;
    }

    const d = dialog.create({
        title: "진단검사 이메일 일괄 전송",
        type: "info",
        content: () =>
            h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
                h("p", `진단완료(리포트 생성) 학생 총 ${completedStudents.length}명 중:`),
                alreadySentStudents.length > 0
                    ? h("p", { style: "color: #999;" }, `- 이미 전송된 학생: ${alreadySentStudents.length}명 제외`)
                    : null,
                noEmailStudents.length > 0
                    ? h("p", { style: "color: #f56c6c;" }, `- 이메일 미등록 학생: ${noEmailStudents.length}명 제외`)
                    : null,
                h(
                    "p",
                    { style: "font-weight: bold; font-size: 15px; color: #18a058; margin-top: 6px;" },
                    `총 ${targetStudents.length}명에게 결과리포트 이메일을 일괄 전송하시겠습니까?`
                ),
            ]),
        positiveText: "일괄 전송",
        negativeText: "취소",
        onPositiveClick: () => {
            d.loading = true;
            isSendingBulkEmail.value[project.SK] = true;
            sendUnsentProjectResultEmailsCallable({
                projectSK: project.SK,
            })
                .then((res: any) => {
                    if (common.evalFunctionResult(res)) {
                        const payload = res.data?.data || res.data || {};
                        const targetCount = payload.targetCount ?? targetStudents.length;
                        const successCount = payload.successCount ?? targetStudents.length;
                        const failCount = payload.failCount ?? 0;
                        const updatedExaminees = payload.updatedExaminees;

                        if (updatedExaminees && Array.isArray(updatedExaminees)) {
                            for (const updated of updatedExaminees) {
                                const found = project.examinees?.find((e) => e.SK === updated.SK);
                                if (found) {
                                    found.email_sent = updated.email_sent;
                                    found.email_sent_at = updated.email_sent_at;
                                }
                            }
                        }
                        triggerModalProjectUpdate();
                        if (failCount > 0) {
                            notification.warning({
                                title: "이메일 전송 부분 완료",
                                description: `총 ${targetCount}명 중 ${successCount}명 성공, ${failCount}명 실패했습니다.`,
                                duration: 4000,
                            });
                        } else {
                            notification.success({
                                title: "이메일 전송 완료",
                                description: `총 ${targetCount}명의 학생에게 이메일이 성공적으로 전송되었습니다.`,
                                duration: 3000,
                            });
                        }
                        d.destroy();
                    } else {
                        d.loading = false;
                        notification.error({
                            title: "이메일 일괄 전송 실패",
                            description: common.getResultError(res) || "이메일 일괄 전송에 실패했습니다.",
                            duration: 3000,
                        });
                    }
                })
                .catch((err: any) => {
                    d.loading = false;
                    notification.error({
                        title: "오류 발생",
                        description: err.message || "이메일 일괄 전송 중 오류가 발생했습니다.",
                        duration: 3000,
                    });
                })
                .finally(() => {
                    isSendingBulkEmail.value[project.SK] = false;
                });

            return false;
        },
    });

}




function showEndDateChangeDialog(project: Project) {
    const newEndDateRef = ref<number | null>(null);
    dialog.create({
        title: "종료일 변경",
        content: () =>
            h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
                h("p", `"${project.name}" 프로젝트의 종료일을 변경합니다.`),
                h(NDatePicker, {
                    value: newEndDateRef.value,
                    onUpdateValue: (value) => {
                        newEndDateRef.value = value;
                    },
                    type: "date",
                    style: "width: 100%",
                }),
            ]),
        positiveText: "확인",
        negativeText: "취소",
        onPositiveClick: async () => {
            if (!newEndDateRef.value) {
                message.error("새로운 종료일을 선택해주세요.");
                return false; // Keep dialog open
            }
            await updateProjectEndDate(project, newEndDateRef.value);
        },
    });
}

async function updateProjectEndDate(project: Project, newEndDate: number) {
    loading.value = true;
    try {
        const res = await updateProjectEndDateCallable({
            SK: project.SK,
            end_target_date: common.getYYYYMMDD(newEndDate),
        });

        if (common.evalFunctionResult(res)) {
            const index = diagnosisItems.value.findIndex((p) => p.SK === project.SK);
            if (index !== -1) {
                diagnosisItems.value[index].end_target_date = common.getYYYYMMDD(newEndDate);
            }
            message.success("종료일이 성공적으로 변경되었습니다.");
        } else {
            notification.error({
                title: "업데이트 실패",
                description: common.getResultError(res) || "종료일 변경에 실패했습니다.",
                duration: 3000,
            });
        }
    } catch (e: any) {
        notification.error({
            title: "오류 발생",
            description: e.message || "종료일 변경 중 오류가 발생했습니다.",
            duration: 3000,
        });
    } finally {
        loading.value = false;
    }
}

async function viewResult(project: Project) {
    loading.value = true;
    try {
        const result = await getProjectContainsExamnineesCallable({
            SK: project.SK,
        });
        if (common.evalFunctionResult(result)) {
            const examinees = common.getItemListFromFunctionResult(result) as Examinee[];
            if (isComponentMounted) {
                selectedProjectForModal.value = { ...project, examinees: examinees };
                showExamineeModal.value = true;
            }
        } else {
            notification.error({
                title: "정보 로딩 실패",
                description: common.getResultError(result) || "학생 정보를 불러오는데 실패했습니다.",
                duration: 3000,
            });
        }
    } catch (e: any) {
        notification.error({
            title: "오류 발생",
            description: e.message || "학생 정보 로딩 중 오류가 발생했습니다.",
            duration: 3000,
        });
    } finally {
        loading.value = false;
    }
}

let isComponentMounted = true;
let refreshInterval: any = null;

watch(showExamineeModal, (newVal) => {
    if (newVal && isComponentMounted) {
        refreshInterval = setInterval(async () => {
            if (selectedProjectForModal.value && selectedProjectForModal.value.SK) {
                try {
                    const res = await getProjectCallable({ SK: selectedProjectForModal.value.SK });
                    if (common.evalFunctionResult(res)) {
                        const project = common.getItemFromFunctionResult(res) as Project;
                        const result = await getProjectContainsExamnineesCallable({
                            SK: project.SK,
                        });
                        if (common.evalFunctionResult(result)) {
                            const examinees = common.getItemListFromFunctionResult(result) as Examinee[];
                            selectedProjectForModal.value = { ...project, examinees: examinees };
                        }
                    }
                } catch (e) {
                    console.error("Silent refresh error:", e);
                }
            }
        }, 15000);
    } else {
        if (refreshInterval) {
            clearInterval(refreshInterval);
            refreshInterval = null;
        }
    }
});

onUnmounted(() => {
    isComponentMounted = false;
    if (refreshInterval) {
        clearInterval(refreshInterval);
        refreshInterval = null;
    }
});

async function openProject(project: Project) {
    loading.value = true;
    try {
        const result = await openOneProjectCallable({ SK: project.SK });
        if (common.evalFunctionResult(result)) {
            notification.warning({
                title: "요청 성공",
                description: "검사 오픈 요청이 성공 했습니다.",
                duration: 3000,
            });
            wrappedRefreshDiagnosis({ status: currentTab.value });
        } else {
            notification.error({
                title: "요청 실패",
                description: common.getResultError(result) || "검사 오픈 요청이 실패 했습니다.",
                duration: 3000,
            });
        }
    } catch (error: any) {
        notification.error({
            title: "요청 실패",
            description: error || "검사 오픈 요청이 실패 했습니다.",
            duration: 3000,
        });
    } finally {
        loading.value = false;
    }
}

async function doRequestExamineeReport(projectSK: string) {
    isDoingJob.value = true;
    isStudentReporting.value[projectSK] = true;
    try {
        const result = await requestProjectReportGenerationCallable({
            SK: projectSK,
        });
        if (common.evalFunctionResult(result)) {
            notification.warning({
                title: "요청 성공",
                description: "학생들 리포트 생성 요청이 성공 했습니다.",
                duration: 3000,
            });
        } else {
            notification.error({
                title: "요청 실패",
                description: common.getResultError(result) || "학생들 리포트 생성 요청이 실패 했습니다.",
                duration: 3000,
            });
        }
    } catch (error: any) {
        notification.error({
            title: "요청 실패",
            description: error || "학생들 리포트 생성 요청이 실패 했습니다.",
            duration: 3000,
        });
    } finally {
        isStudentReporting.value[projectSK] = false;
        isDoingJob.value = false;
    }
}

async function doRequestExamineeReportUsingSheet(projectSK: string) {
    const sheetIdInputRef = ref("");

    dialog.create({
        title: "Google Sheet URL 입력",
        content: () =>
            h("div", { style: "display: flex; flex-direction: column; gap: 8px;" }, [
                h("p", "리포트를 생성할 Google Sheet의 전체 URL 또는 ID를 입력해주세요."),
                h(NInput, {
                    value: sheetIdInputRef.value,
                    onUpdateValue: (value) => {
                        sheetIdInputRef.value = value;
                    },
                    placeholder: "https://docs.google.com/spreadsheets/d/...",
                }),
            ]),
        positiveText: "생성 요청",
        negativeText: "취소",
        onPositiveClick: async () => {
            const sheetId = sheetIdInputRef.value.trim();
            if (!sheetId) {
                message.error("Google Sheet URL을 입력해야 합니다.");
                return false; // Prevent dialog from closing
            }
            loading.value = true;
            isStudentReportingUsingSheet.value[projectSK] = true; // API 요청 시작 시 로딩 상태 활성화
            try {
                const result = await requestProjectReportGenerationUsingSheetCallable({
                    SK: projectSK,
                    sheetId: sheetId,
                });
                if (common.evalFunctionResult(result)) {
                    loading.value = false;
                    notification.success({
                        title: "요청 성공",
                        description: "학생들 리포트 생성 요청이 성공했습니다.",
                        duration: 3000,
                    });
                } else {
                    loading.value = false;
                    notification.error({
                        title: "요청 실패",
                        description: common.getResultError(result) || "학생들 리포트 생성 요청이 실패했습니다.",
                        duration: 3000,
                    });
                }
            } catch (error: any) {
                loading.value = false;
                notification.error({
                    title: "요청 실패",
                    description: error.message || "학생들 리포트 생성 요청 중 오류가 발생했습니다.",
                    duration: 3000,
                });
            } finally {
                isStudentReportingUsingSheet.value[projectSK] = false;
                loading.value = false;
                return true; // 다이얼로그 닫기
            }
        },
    });
}

async function downloadTeacherReportFile(projectItem: Project) {
    loading.value = true;
    let filename = "";
    if (projectItem.type == "putt_u" || projectItem.type == "tec") {
        filename = `${projectItem.major}_${projectItem.class}학년.xlsx`;
    } else {
        filename = `${projectItem.grade}학년_${projectItem.class}반.xlsx`;
    }
    await downloadReportFile(projectItem.teacher_report_file, filename);
    loading.value = false;
}
async function downloadExamineeReportFile(examineeItem: Examinee, classType?: string) {
    isDoingJob.value = true;
    isDownloadingStudentReport.value[examineeItem.SK] = true;
    const isUniversityType = classType === "putt_u" || classType === "tec";
    const numStr = isUniversityType ? examineeItem.student_num : examineeItem.num;
    let typePrefix = "";
    if (classType) {
        typePrefix = classType.split("_")[0].toUpperCase() + "-";
    }
    let filename = `${typePrefix}${numStr}_${examineeItem.name}.pdf`;
    await downloadReportFile(examineeItem.report_file, filename);
    isDownloadingStudentReport.value[examineeItem.SK] = false;
    isDoingJob.value = false;
}

async function deleteExamineeReportFile(examineeItem: Examinee) {
    showActionDialog({
        title: "확인",
        content: () =>
            h("div", null, [
                h("p", { style: { color: "red", fontWeight: "bold" } }, "정말로 검사를 삭제하시겠습니까?"),
            ]),
        positiveText: "네",
        negativeText: "아니요",
        positiveButtonProps: { type: "default" },
        confirmButtonLoadingText: "처리 중...",
        onConfirm: async () => {
            isDoingJob.value = true;
            isDeletingStudentReport.value[examineeItem.SK] = true;
            try {
                const result = await deleteExaminieeReportDataCallable({ SK: examineeItem.SK });
                if (common.evalFunctionResult(result)) {
                    notification.warning({
                        title: "삭제 성공",
                        description: "결과리포트 삭제 성공",
                        duration: 3000,
                    });
                    if (selectedProjectForModal.value) {
                        viewResult(selectedProjectForModal.value);
                    }
                } else {
                    notification.error({
                        title: "삭제 실패",
                        description: common.getResultError(result) || "결과리포트 삭제를 실패 했습니다.",
                        duration: 3000,
                    });
                }
            } catch (error: any) {
                notification.error({
                    title: "삭제 실패",
                    description: error || "검사 삭제 요청이 실패 했습니다.",
                    duration: 3000,
                });
            } finally {
                isDeletingStudentReport.value[examineeItem.SK] = false;
                isDoingJob.value = false;
            }
        },
    });
}

async function handleTabChange(tabName: string) {
    const oldTab = currentTab.value;
    currentTab.value = tabName;
    if (tabName === TAB.COMPLETED) {
        showCompletedResults.value = false;
        dateRange.value = null;
        if (oldTab !== TAB.COMPLETED) {
            diagnosisItems.value = [];
        }
    } else {
        await wrappedRefreshDiagnosis({ status: tabName });
    }
}

onMounted(() => {
    wrappedRefreshDiagnosis({ status: currentTab.value });
});
</script>

<style scope></style>
